const indexItems = [
  { title: '创造营2026 · 全程追踪', count: '128篇', tag: '热门' },
  { title: '电竞世界杯 · 赛事速递', count: '96篇', tag: '热门' },
  { title: '歌手2026 · 每期回顾', count: '84篇', tag: '更新中' },
  { title: '街舞大赛 · 深度分析', count: '73篇', tag: '' },
  { title: 'AI创作大赛 · 行业观察', count: '58篇', tag: '' },
  { title: '美食大赛 · 对决实录', count: '47篇', tag: '' },
  { title: '选秀综艺 · 内幕揭秘', count: '215篇', tag: '热门' },
  { title: '电竞赛场 · 选手档案', count: '162篇', tag: '' },
  { title: '大赛吃瓜 · 名场面合集', count: '89篇', tag: '推荐' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按大赛分类浏览系列内容，找到你最关注的赛事专题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer bg-background-100 rounded-xl px-5 py-4 flex items-center justify-between hover:bg-primary-50 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${
                    i % 3 === 0 ? 'ri-movie-line' :
                    i % 3 === 1 ? 'ri-gamepad-line' :
                    'ri-music-line'
                  } text-lg text-accent-500`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count} 内容</span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {item.tag && (
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
                    item.tag === '热门' ? 'bg-primary-100 text-primary-600' :
                    item.tag === '推荐' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-600'
                  }`}>
                    {item.tag}
                  </span>
                )}
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors duration-200"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}